import { useEffect } from 'react';
import {
  getOrganizationSchema,
  getFAQSchema,
  getBreadcrumbSchema,
  getWebSiteSchema,
  getReviewsSchema,
  getWebPageSchema
} from '../../utils/schemaOrg';

export default function SchemaOrg() {
  useEffect(() => {
    const schemas = [
      getOrganizationSchema(),
      getFAQSchema(),
      getBreadcrumbSchema(),
      getWebSiteSchema(),
      getReviewsSchema(),
      getWebPageSchema()
    ];

    schemas.forEach((schema, index) => {
      const scriptId = `schema-${index}`;
      
      // Supprimer l'ancien script s'il existe
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
      
      // Créer et injecter le nouveau script
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`schema-${index}`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  return null;
}
